import { api } from './axios';
import { authService } from './auth';
import type { Pais, Estado, Cidade } from '../models';

/**
 * Serviço para gerenciar dados de localização (Países, Estados, Cidades)
 */
class LocationService {
  /**
   * Buscar todos os países com seus estados e cidades aninhados
   */
  async getPaises(): Promise<Pais[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Pais[]>('/paises');
    return response.data;
  }

  /**
   * Buscar todos os estados com suas cidades
   */
  async getEstados(): Promise<Estado[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Estado[]>('/estados');
    return response.data;
  }

  /**
   * Buscar todas as cidades
   */
  async getCidades(): Promise<Cidade[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Cidade[]>('/cidades');
    return response.data;
  }

  /**
   * Buscar estados de um país específico
   */
  async getEstadosByPais(paisId: number): Promise<Estado[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Estado[]>(`/paises/${paisId}/estados`);
    return response.data;
  }

  /**
   * Buscar cidades de um estado específico
   */
  async getCidadesByEstado(estadoId: number): Promise<Cidade[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Cidade[]>(`/estados/${estadoId}/cidades`);
    return response.data;
  }
}

export const locationService = new LocationService();
